<template>
  <BaseTemplate :currentUser="currentUser">
    <div class="change-password">
      <Title :jpn="t('パスワード変更')" />
      <LabelInput class="label-input" :labelText="t('新しいパスワード')">
        <TextBox
          class="text-box password"
          inputType="password"
          :value="password"
          :placeholder="t('半角英数字15文字以内')"
          @handleTextInput="inputPassword"
        />
        <ErrorMessage
          v-if="errorMessagePassword"
          class="error-message"
          :message="t(errorMessagePassword)"
        />
      </LabelInput>
      <LabelInput class="label-input" :labelText="t('新しいパスワード確認用')">
        <TextBox
          class="text-box password confirm"
          inputType="password"
          :value="confirmPass"
          :placeholder="t('半角英数字15文字以内')"
          @handleTextInput="inputConfirmPass"
        />
        <ErrorMessage
          v-if="errorMessagePassword"
          class="error-message"
          :message="t(errorMessagePassword)"
        />
      </LabelInput>
      <BuyButton
        class="square-button setup"
        :isArrow="false"
        :text="t('変更する')"
        @handleSquareBtnClick="updatePassword"
      />
      <SquareButton
        class="label-input nomt square-button"
        :text="t('戻る')"
        @handleSquareBtnClick="goToBack"
      />
      <AlertSuccess
        ref="alertSuccess"
        :isShow="isShowAlertSuccess"
        :text="t('変更が完了しました')"
        v-click-outside="closeAlertSuccess"
      />
    </div>
  </BaseTemplate>
</template>

<script>
import { mapGetters } from 'vuex';
import ClickOutside from 'vue-click-outside';

import BaseTemplate from '@/components/templates/BaseTemplate.vue';
import AlertSuccess from '@/components/atoms/AlertSuccess.vue';
import TextBox from '@/components/atoms/TextBox.vue';
import ErrorMessage from '@/components/atoms/ErrorMessage.vue';
import LabelInput from '@/components/molecules/LabelInput.vue';
import BuyButton from '@/components/atoms/BuyButton.vue';
import SquareButton from '@/components/atoms/SquareButton.vue';
import Title from '@/components/molecules/Title02.vue';
import t from '@/plugins/i18n';

export default {
  name: 'ChangePassword',
  mixins: [t],

  components: {
    BaseTemplate,
    AlertSuccess,
    TextBox,
    ErrorMessage,
    LabelInput,
    BuyButton,
    SquareButton,
    Title,
  },

  directives: {
    ClickOutside,
  },

  data: () => ({
    password: null,
    confirmPass: null,
    isShowAlertSuccess: false,
    errorMessagePassword: null,
  }),

  computed: {
    ...mapGetters({
      currentUser: 'user/currentUser',
      changeUserPasswordResult: 'user/changeUserPasswordResult',
    }),
  },

  watch: {
    changeUserPasswordResult(newVal) {
      if (newVal) {
        if (newVal.state === 200) {
          this.$store.dispatch('user/clearChangeUserPasswordResult');
          this.isShowAlertSuccess = true;
        } else {
          const { pass } = newVal.errors;
          this.errorMessagePassword = pass ? pass[0] : null;
        }
      }
    },
  },

  created() {
    this.$store.dispatch('user/setCurrentUser', { token: 'yugi' });
  },

  mounted() {
    this.popupItem = this.$refs.alertSuccess;
  },

  methods: {
    inputPassword(password) {
      this.password = password;
    },
    inputConfirmPass(confirmPass) {
      this.confirmPass = confirmPass;
    },
    updatePassword() {
      const postParams = {
        pass: this.password,
        confirmPass: this.confirmPass,
      };
      this.$store.dispatch('user/changeUserPassword', { postParams });
    },
    closeAlertSuccess() {
      if (this.isShowAlertSuccess) {
        this.isShowAlertSuccess = false;
        this.$router.push('./');
      }
    },
    goToBack() {
      this.$router.push('/');
    },
  },
};
</script>

<style lang="scss" scoped>
.change-password{
  padding-top: 30px;
  padding-bottom: 50px;
  max-width: 600px;
  margin: 0px auto;
  text-align: center;
  .change-password-title{
    .text{
      height: 44px;
      font-family: $notoSerif;
      font-size: 30px;
      font-weight: 700;
      text-shadow: $titleShadow;
    }
  }
  .square-button{
    font-size: medium;
    &.setup{
      &:hover{
        opacity: 0.7;
      }
    }
  }
  .label-input{
    width: 480px;
    margin-top: 20px;
    margin-left: auto;
    margin-right: auto;
    @media screen and (max-width: $tabletWidth) {
      width: 100%;
    }
    .text-box{
      margin-top: 10px;
      width: 100%;
      height: 40px;
    }
  }
  .square-button{
    width: 200px;
    height: 50px;
    margin: 40px auto 0px;
  }
}
</style>
